export enum Language {
  ENGLISH = 'en',
  FRENCH = 'fr',
}